import {
  SET_SELECTED_DATE_RANGE,
  SET_SELECTED_FACILITY,
  TrackOpticsPageType
} from "../actions/trackOpticsPage";
import ITrackOpticsPageState from "interfaces/ITrackOpticsPageState";

const initialState: ITrackOpticsPageState = {
  selectedDateRange: null,
  selectedFacility: null
};
export default (
  state = initialState,
  action: TrackOpticsPageType
): ITrackOpticsPageState => {
  switch (action.type) {
    case SET_SELECTED_DATE_RANGE:
      return {
        ...state,
        selectedDateRange: action.selectedDateRange
      };
    case SET_SELECTED_FACILITY:
      return {
        ...state,
        selectedFacility: action.selectedFacility
      };
    default:
      return state;
  }
};
